import { useNavigate } from 'react-router';

import { useModelingDeployQuery } from '@/hook';
import { Label, VFlex, VSpacer, VStack, useVModal } from '@/package';
import type { Modeling } from '@/type';

export const useDeploymentModal = () => {
  const { openConfirm } = useVModal();
  const { mutate: deploy } = useModelingDeployQuery();
  const navigate = useNavigate();

  const onDeploy = ({ modeling }: { modeling?: Modeling }) => {
    openConfirm({
      title: 'Deployment',
      message: () => {
        return (
          <VStack>
            <div className="text-body-xl">Start Deployment</div>
            <VSpacer size={1} />
            <div className="text-body-lg">
              Once deployment begins, it may take some time to complete. You can
              check the progress on the Deployment page.
            </div>
            <VSpacer size={2.5} />
            <VFlex gap={0.25}>
              <Label className="size-4 text-gray-500" />
              <div className="text-body-lg">{modeling?.name}</div>
            </VFlex>
          </VStack>
        );
      },
      confirmText: 'Deployment',
      cancelText: 'Cancel',
      onConfirm: () => {
        deploy(
          {
            pModelingID: Number(modeling?.id),
          },
          {
            onSuccess: () => {
              navigate('/deployment');
            },
          },
        );
      },
    });
  };

  return {
    onDeploy,
  };
};
